import React, { useState } from 'react';

function MarketplaceMenu({ categories = [], onCategorySelect }) {
  const [activeCategoryId, setActiveCategoryId] = useState(null);

  const toggleAccordion = (categoryId) => {
    setActiveCategoryId((prev) => (prev === categoryId ? null : categoryId));
  };

  return (
    <>
      {(categories || []).map((parent) => (
        <div key={parent.id} className='mb-3'>
          <a
            className='d-flex align-items-center text-body text-decoration-none'
            data-bs-toggle='collapse'
            href={`#category-collapse-${parent.id}`}
            role='button'
            aria-expanded={activeCategoryId === parent.id}
            aria-controls={`category-collapse-${parent.id}`}
            onClick={() => toggleAccordion(parent.id)}
          >
            <i
              className={`mdi ${
                activeCategoryId === parent.id
                  ? 'mdi-folder-open'
                  : 'mdi-folder'
              } font-size-20 text-warning me-2`}
            />
            {parent.name}
            <i className='mdi mdi-chevron-down ms-auto' />

            <span
              className={`badge ms-2 ${
                (parent.totalCount || 0) > 0
                  ? 'bg-primary  fw-bold'
                  : 'bg-light text-dark'
              }`}
            >
              {parent.totalCount || 0}
            </span>
          </a>

          <div
            id={`category-collapse-${parent.id}`}
            className={`collapse ${
              activeCategoryId === parent.id ? 'show' : ''
            }`}
          >
            <ul className='list-unstyled mt-2 ps-4'>
              {parent.children?.length ? (
                parent.children.map((child) => (
                  <li
                    key={child.id}
                    className='d-flex align-items-center py-1'
                    onClick={() =>
                      onCategorySelect && onCategorySelect(child.id)
                    }
                    style={{ cursor: 'pointer' }}
                  >
                    <i className='mdi mdi-subdirectory-arrow-right font-size-20 text-warning me-2' />

                    <span className='flex-grow-1'>{child.name}</span>
                    {child.totalCount > 0 && (
                      <span className='badge bg-light text-dark fw-bold'>
                        {child.totalCount}
                      </span>
                    )}
                  </li>
                ))
              ) : (
                <li className='text-muted small ps-1'>No subcategories</li>
              )}
            </ul>
          </div>
        </div>
      ))}
    </>
  );
}

export default MarketplaceMenu;
